import Select, { SelectProps } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';

import { ReactComponent as DownIcon } from '../assets/icons/main/chevron-down-icon.svg';
import { useTheme } from '@mui/material';
import { palette } from '../theme/palette';

const Styles = {
  helperText: { marginInline: '14px', marginTop: '4px' },
};

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const SelectComponent = ({
  name,
  value,
  options,
  onChange,
  placeholder,
  disabled,
  variant = 'outlined',
  width = '100%',
  sx = {},
  error,
  helperText,
  margin = '0px',
  MenuProps = {},
  autoFocus,
  InputProps,
  selectkey,
  helpersx
}: any) => {
  const theme: any = useTheme();
  return (
    <FormControl sx={[{ width }, sx]}>
      <Select
        key={selectkey}
        autoFocus={autoFocus}
        name={name}
        value={value == 0 ? '0' : value || ''}
        IconComponent={(props: SelectProps) => <DownIcon className={`material-icons ${props.className}`}
          style={{ color: palette.info.dark, opacity: disabled ? '0.5' : '0.7' }}
        />}
        onChange={onChange}
        displayEmpty
        disabled={disabled}
        variant={variant}
        error={error}
        inputProps={{
          ...InputProps,
          MenuProps: {
            MenuListProps: {
              sx: {
                backgroundColor: palette.primary.contrastText,
              }
            }
          }
        }}
        MenuProps={MenuProps}
        renderValue={(selected) => {          
          if (selected === '' || selected === null || selected === undefined || selected === '0') {
            return (
              <em style={{ color: '#c8c8ca', fontStyle: 'italic' }}>
                {/* theme.palette.text.secondary */}
                {placeholder}
              </em>
            );
          }
          const selectedOption = options.find((option: any) => option.value === selected);
          return selectedOption ? selectedOption.label : '';
        }}
      >
        {placeholder && (
          <MenuItem disabled value=''>
            <em style={{ color: '#c8c8ca', fontStyle: 'italic' }}>{placeholder}</em>
          </MenuItem>
        )}
        {options.map((option: any) => (
          <MenuItem key={option.value} value={option.value} >
            {option.label}
          </MenuItem>
        ))}
      </Select>
      {error && (
        <Typography variant='body2' color='error' sx={{ ...Styles.helperText, ...helpersx }}>
          {helperText}
        </Typography>
      )}
    </FormControl>
  );
};

export default SelectComponent;
